/**
 * Helpers to unwrap API responses from appointment-related modules.
 * Rails returns { data: record } and Axios wraps it as response.data = { data: record }.
 */

export function extractRecord(response) {
  const body = response?.data;
  if (
    body &&
    typeof body === 'object' &&
    !Array.isArray(body) &&
    'data' in body
  ) {
    return body.data;
  }
  return body;
}

export function extractList(response) {
  const body = response?.data;
  if (Array.isArray(body)) return body;
  if (body?.data && Array.isArray(body.data)) return body.data;
  if (body?.payload && Array.isArray(body.payload)) return body.payload;
  return [];
}
